<template>
  <el-dialog
  class="ModalShare"
  :show-close="true"
  :visible="visible"
  :before-close="handleClose">
    <div
    slot="title"
    class="ModalShare__header">
      <span class="ModalShare__title">Share download link</span>
    </div>
    <div
    v-if="file.shareLink"
    class="ModalShare__body">
      <CopyInput
      :disabled="true"
      :inputValue="file.shareLink" />
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CopyInput from '@/components/common/CopyInput'

export default {
  name: 'ModalShare',

  components: {
    CopyInput
  },

  computed: {
    ...mapGetters('modal', [
      'fileByModal',
      'visibleByModal'
    ]),
    file () {
      return this.fileByModal('share')
    },
    visible () {
      return this.visibleByModal('share')
    }
  },

  methods: {
    ...mapActions('modal', [
      'hideModal'
    ]),
    handleClose () {
      this.hideModal('share')
    }
  }
}
</script>

<style lang="scss">
@import 'ModalShare';
</style>
